'use strict';

var _ = require('underscore');
var isSimpleObject = require('./isSimpleObject');
var deepClone = require('./deepClone');
var deepExtend = require('./deepExtend');

/**
 * Remove keys containing values from options
 * @param {Object|Array} object - input object
 * @param {Object} [options]
 * @param {Boolean} [options.emptyObjects = true]
 * @param {Boolean} [options.undefinedValues = true]
 * @param {Boolean} [options.nullValues = true]
 * @param {Boolean} [options.emptyArrays = false]
 * @returns {Object} - cleaned up object
 */

var options;

module.exports = function(params, compactOptions) {
	var standartOptions = {
		emptyObjects: true,
		undefinedValues: true,
		nullValues: true,
		emptyArrays: false
	};

	options = _(standartOptions).extend(compactOptions);

	if(isSimpleObject(params)) {
		var newObj = deepClone(params);
		return compactObject(newObj);
	} else if (_(params).isArray()) {
		var newArray = deepExtend([], params);
		return compactArray(newArray);
	}
};

var compactArray = function(array) {
	return _(array)
		.chain()
		.map(function(item) {
			if (isSimpleObject(item)) {
				return compactObject(item);
			} else if (_(item).isArray()){
				return compactArray(item);
			} else {
				return item;
			}
		})
		.reject(function(item) {
			return ((
				_(item).isUndefined() && options.undefinedValues
			) || (
				_(item).isNull() && options.nullValues
			) || (
				isSimpleObject(item) && _(item).isEmpty() && options.emptyObjects
			) || (
				_(item).isArray() && _(item).isEmpty() && options.emptyArrays
			));
		})
		.value();
};

var compactObject = function(object) {
	var omittedKeys = [];

	return _(object)
		.chain()
		.mapObject(function(value, key) {
			if (isSimpleObject(value)) {
				if (!_(value).isEmpty()) {
					value = compactObject(value);
				}

				if (_(value).isEmpty() && options.emptyObjects) {
					omittedKeys.push(key);
				}
			} else if (_(value).isArray()) {
				value = compactArray(value);

				if (_(value).isEmpty() && options.emptyArrays) {
					omittedKeys.push(key);
				}
			} else {
				if (
					(_(value).isUndefined() && options.undefinedValues) ||
					(_(value).isNull() && options.nullValues)
				) {
					omittedKeys.push(key);
				}
			}

			return value;
		})
		.omit(omittedKeys)
		.value();
};


